import React, { useState, useEffect, useContext } from 'react'
import { useForm, FormProvider } from 'react-hook-form';
import { Link, useNavigate } from 'react-router-dom';
import { Input, Checkbox } from '@components';
import { post } from '@utils/axios_api';
import { AuthContext } from '@context';

import './Login.css';

const LoginPage = () => {
  const { login  } = useContext(AuthContext);
  const navigate = useNavigate();
  const [serverError, setServerError] = useState('');

  const methods = useForm({
    defaultValues: { id: '', password: '', saveId: false },
  });

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    const isIdSaved = localStorage.getItem('isIdSaved') === 'true';
    if (isIdSaved) {
        const savedUserId = localStorage.getItem('savedUserId');
        if (savedUserId) setValue('id', savedUserId);
        setValue('saveId', true);
    }
}, [setValue]);

const onSubmit = async (data) => {
  setServerError('');
  try {
      const loginData = { username: data.id, password: data.password };
      const loginInfo = await post('/login', loginData);

      // console.log('loginInfo:', loginInfo);
      // if (isIdSaved) {
      //     localStorage.setItem('savedUserId', data.id);
      // } else {
      //     localStorage.removeItem('savedUserId');
      // }
      if (data.saveId) {
          localStorage.setItem('savedUserId', data.id);
          localStorage.setItem('isIdSaved', 'true');
      } else {
          localStorage.removeItem('savedUserId');
          localStorage.setItem('isIdSaved', 'false');
      }
      
      login(loginInfo);

      // 임시 비밀번호 상태 → 비밀번호 변경 화면으로 강제 이동
      if (loginInfo.forceChangePw === 'Y') {
        navigate('/change-password');
      } else {
        navigate('/main');
      }
      reset();
  } catch (err) {
    setServerError(err.response?.data?.errorMessage || '로그인에 실패했습니다.');
      console.error(err);
  }
};

return (
  <FormProvider {...methods}>
  <form onSubmit={handleSubmit(onSubmit)}>
    <div className="main-container">
      <div className="login-container">
        {/* 로고 영역 */}
        <div className="logo">
          <Link to="/">
            <img src="/img/logo.png" alt="회사 로고" style={{ cursor: 'pointer' }} />
          </Link>
        </div>

        {/* 로그인 폼 */}
        <div className="login-form">
          <h1>중대재해 예방 플랫폼</h1>
          {serverError && <p className="error-message red">{serverError}</p>}
          <div className="login_input_wrap">
            <Input
                name="id"
                type="text"
                placeholder="아이디를 입력해 주세요."
                required={true}
                maxLength="30"
            />
            <Input
                name="password"
                type="password"
                placeholder="비밀번호를 입력해 주세요."
                required={true}
                maxLength="20"
            />
          </div>
          <div className="remember-me">
            <Checkbox
                label="아이디 저장"
                name="saveId"
                required={false}
            />
          </div>
          <button type="submit" className="login-button"  disabled={isSubmitting} >{isSubmitting ? '로그인 중...' : '로그인'}</button>

          {/* 아이디/비밀번호 찾기 링크 */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '14px', fontSize: '0.9rem' }}>
            <Link to="/forgot-id" style={{ color: '#555' }}>아이디 찾기</Link>
            <span style={{ color: '#ddd' }}>|</span>
            <Link to="/forgot-password" style={{ color: '#555' }}>비밀번호 찾기</Link>
          </div>
        </div>
      </div>
    </div>
      <div style={{backgroundColor:"#f5f5f5", fontSize:"1.1rem"}}>
        <div className="container my-auto">
          <div className="copyright text-center my-auto">
            <span>Copyright &copy; 안전 센터 1566-3886</span>
            <span style={{marginLeft:"10px"}}><Link to="http://www.atos.co.kr/">주식회사 아토스</Link></span>
          </div>
        </div>
      </div>
  </form>
  
  </FormProvider>
 );
};

export {LoginPage};